import { useEffect, useState } from 'react';
import { pushEvent, ANALYTICS_EVENTS } from '../utils/analytics';

export function usePaymentReuse(tokenFromUrl, getApiToken) {
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = tokenFromUrl || localStorage.getItem('upgradeToken');

    if (!token) {
      setError('No payment token supplied.');
      setLoading(false);
      pushEvent({
        event: ANALYTICS_EVENTS.PAYMENT_REUSE_TOKEN_ERROR,
        errorType: 'token_missing',
        errorMessage: 'No payment token supplied.',
        source: window.location.pathname,
      });
      return;
    }

    const consumeToken = async () => {
      setLoading(true);
      try {
        const authToken = typeof getApiToken === 'function' ? await getApiToken() : null;
        if (!authToken) {
          throw new Error('Authentication required to use saved payment link.');
        }
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/stripe/consume-temp-payment-meta?token=${encodeURIComponent(token)}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        const data = await response.json();

        if (!response.ok) {
          pushEvent({
            event: ANALYTICS_EVENTS.PAYMENT_REUSE_TOKEN_ERROR,
            errorType: 'token_invalid_or_expired',
            errorMessage: data.error || `HTTP error! status: ${response.status}`,
            source: window.location.pathname,
          });
          throw new Error(data.error || `HTTP error! status: ${response.status}`);
        }
        
        setMeta(data); // Expects { customerId, paymentMethodId }
        localStorage.removeItem('upgradeToken'); // Prevent double use
        pushEvent({
          event: ANALYTICS_EVENTS.PAYMENT_REUSE_TOKEN_SUCCESS,
          source: window.location.pathname,
          customerId: data.customerId,
          paymentMethodId: data.paymentMethodId,
        });
      } catch (e) {
        console.error('Failed to consume payment token:', e);
        setError(e.message || 'Failed to consume payment token.');
        pushEvent({
          event: ANALYTICS_EVENTS.PAYMENT_REUSE_TOKEN_ERROR,
          errorType: 'token_consumption_failed',
          errorMessage: e.message,
          source: window.location.pathname,
        });
      } finally {
        setLoading(false);
      }
    };

    consumeToken();
  }, [tokenFromUrl, getApiToken]);

  return { meta, error, loading };
}

// When tracking analytics, use:
// pushEvent({
//   event: ANALYTICS_EVENTS.TEMP_PAYMENT_TOKEN_CREATED,
//   // ...other params...
// });
